import { EStudentPaymentStatus } from '@constants';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { sdk } from '@/services';

const UserInfoService = sdk.getService('UserInfoService');

export const useMutateStudentPaymentStatus = (userId?: string) => {
  const queryClient = useQueryClient();

  const invalidateQueries = () => {
    queryClient.invalidateQueries({ queryKey: ['students'] });
    queryClient.invalidateQueries({ queryKey: ['user-info'] });
    if (userId) {
      queryClient.invalidateQueries({ queryKey: ['user-info', userId] });
    }
  };

  const { mutate: updatePaymentStatus, isPending: isUpdatingOne } = useMutation({
    mutationFn: (paymentStatus: EStudentPaymentStatus) =>
      UserInfoService.updatePaymentStatus(userId!, paymentStatus),
    onSuccess: invalidateQueries
  });

  const { mutate: changePaymentStatusInBulk, isPending: isUpdatingBulk } = useMutation({
    mutationFn: ({ studentIds, status }: { studentIds: string[]; status: EStudentPaymentStatus }) =>
      UserInfoService.changePaymentStatusInBulk(studentIds, status),
    onSuccess: invalidateQueries
  });

  return {
    updatePaymentStatus,
    changePaymentStatusInBulk,
    isWorking: isUpdatingOne || isUpdatingBulk
  };
};
